const NumberField = ({ name, value, onChange, disabled }) => {
  return (
    <input
      style={{
        minWidth: "120px",
        // width: "120px", // All cells same width
        height: "28px", // Excel-like height
        padding: "2px 6px",
        margin: 0,
        borderRadius: 0,
        fontSize: "13px",
        boxSizing: "border-box",
      }}
      type="number"
      disabled={disabled}
      className="form-control"
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
    />
  );
};

export default NumberField;
